module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Gipf-Oberfrick-289f460481873c76626b46e1607c9813.svg";